import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormatDateStringPipe } from "./format-date-string.pipe";

@NgModule({
  imports: [CommonModule],
  declarations: [FormatDateStringPipe],
  exports: [FormatDateStringPipe]
})
export class FormatDateStringPipeModule {}
